import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { signOut, resetPassword, resetEmail, changeAccountInformation } from '../../app/actions/authActions';
import User from '../../components/User';
import Input from '../../components/Input';
import Title from '../../components/Title';
import Button from '../../components/Button';
import AlertMessage from '../../components/AlertMessage';
import { ArrowBold } from '../../static';

import './styles.scss';

const Account = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const profile = useSelector((store) => store.firebase.profile);
	const showAlert = useSelector((store) => store.ui.showAlert);
	const uid = useSelector((state) => state.firebase.auth.uid);

	const [state, setState] = useState({
		email: '',
		firstName: '',
		lastName: '',
		position: '',
		businessName: '',
		address: '',
	});
	
	const handleChangeInput = (target) => {
		setState( (state)=> ({...state,[target.id]:target.value}))
	};

	const handleRessetPassword = () => {
		dispatch(resetPassword(state.email))
	};

	const handleOut = () => {
		dispatch(signOut());
	};

	const handleEditInput = ({id, edit}) => {
		if(edit) {
			if(id === 'email') {
				const email = profile.email ? profile.email : '';
				
				if(email !== state.email) {
					dispatch(resetEmail(state));
				};
			} else {
				if(state[id] !== profile[id]) {
					dispatch(changeAccountInformation({[id]:state[id]}));
				};
			};
		};
	};

	useEffect(()=>{
		!profile.isEmpty && setState((prev) => ({...prev,...profile}));
	},[profile]);

	useEffect(()=>{
		const isNotChangeEmail = showAlert.message && showAlert.message.includes('recent authentication');
		if(isNotChangeEmail) {
			setState((prev) => ({...prev, email: profile.email}));
		};
	},[showAlert,profile]);

	useEffect(()=>{
		if(!uid) {
			history.push('/login');
		};
	}); 

	return (
		<div className="container">
			<div className="account">
				<Title text={"Account Information"} isBig isBold/>
				<div className="account__user">
					<User user={profile} isEditImg isBig/>
				</div>
				<AlertMessage showAlert={showAlert}/> 
				<Input 
					value={state.businessName}
					id='businessName'
					type='text' 
					label='business Name' 
					onChange={handleChangeInput}
					onClick={handleEditInput}
					required 
					isEdit
				/>
				<Input 
					value={state.address}
					id='address'
					type='text' 
					label='facility Address' 
					onChange={handleChangeInput}
					onClick={handleEditInput}
					required 
					isEdit
				/>
				<Input 
					value={state.position}
					id='position'
					type='text' 
					label='position' 
					onChange={handleChangeInput}
					onClick={handleEditInput}
					required 
					isEdit
				/>
				<Input 
					value={state.firstName}
					id='firstName'
					type='text' 
					label='first Name' 
					onChange={handleChangeInput}
					onClick={handleEditInput}
					required 
					isEdit
				/>
				<Input 
					value={state.lastName}
					id='lastName'
					type='text' 
					label='last Name' 
					onChange={handleChangeInput}
					onClick={handleEditInput}
					required 
					isEdit
				/>
				<Input 
					value={state.email}
					id='email'
					type='email' 
					label='email' 
					onChange={handleChangeInput}
					onClick={handleEditInput}
					required
					isEdit
				/>
				<div className="account__btn">
					<Button 
						text={"Change Password"}
						onClick={handleRessetPassword}
					/>
				</div>
				<div className="account__btn account__btn--out">
					<Button 
						text={"Sign Out"} 
						isLight
						rightIcon={<ArrowBold />} 
						onClick={handleOut}
					/>
				</div>
			</div>
		</div>
	);
};

export default Account;
